import { useComponentTexts, useTileTexts, useUrls } from "Store/texts/hooks";

import { Paragraph } from "App/global-style";
import { BaseTile } from "Components/BaseTile";
import { HuseierneMembershipAdvantagesAlert } from "Components/Huseierne";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import React from "react";
import { StandardLogin } from "../StandardLogin";

interface Props {
  productBackendName: ProductBackendName;
}

export const HouseLoginStandard = ({
  productBackendName,
}: Props): React.ReactElement => {
  const [
    {
      loginTile: { headers, descriptions },
    },
    lang,
  ] = useTileTexts();
  const [
    {
      huseierne: { house },
    },
  ] = useComponentTexts();
  const [{ huseierneLandingPageHouse }] = useUrls();
  const header = headers[productBackendName][lang];

  return (
    <BaseTile header={header}>
      <Paragraph>{descriptions[productBackendName][lang]}</Paragraph>
      <Paragraph>{descriptions[`${productBackendName}2`][lang]}</Paragraph>
      <StandardLogin productBackendName={productBackendName} />
      <HuseierneMembershipAdvantagesAlert
        headerText={house.header[lang]}
        buttonText={house.button[lang]}
        infoText={house.info[lang]}
        url={huseierneLandingPageHouse}
      />
    </BaseTile>
  );
};
